import React from 'react';
import { Card, Button, Icon, Divider } from 'semantic-ui-react';

const headerStyle = { fontSize: '90%', textAlign: 'center' };
const normalSize = { fontSize: '100%' };

const EmptyAssets = ({ ctaHandler }) => (
  <Card centered style={headerStyle}>
    <Card.Content>
      <Card.Header>
        Add an Asset!
      </Card.Header>
    </Card.Content>
    <Card.Content>
      <p style={normalSize}>Hello! <Icon name="smile" color="pink" /></p>
      <p style={normalSize}>
        There are no assets in your campaign yet. Use the button below, or the button top right to add your first asset.
      </p>
      <Divider />
      <Button icon labelPosition="left" color="pink" size="large" fluid onClick={ctaHandler}>
        <Icon name="plus" />
        Add an asset...
      </Button>
    </Card.Content>
  </Card>

);

export default EmptyAssets;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-dashboard-cards/empty-assets.js
 **/